import type { ChatType } from '../../services/chat';

// External keeps the original key so drafts saved before threads were split survive.
export function chatDraftKey(patientId: string, chatType: ChatType): string {
    return chatType === 'internal' ? `chat-draft-internal-${patientId}` : `chat-draft-${patientId}`;
}
